export const firebaseConfig = {
  apiKey: "AIzaSyCsnlHvKtbHly0PkVbM6kfvCPNN5ElkwU4",
  authDomain: "ink-enc-bic-soleil-2022.firebaseapp.com",
  projectId: "ink-enc-bic-soleil-2022",
  storageBucket: "ink-enc-bic-soleil-2022.appspot.com",
  messagingSenderId: "433580180010",
  appId: "1:433580180010:web:e65dc8b46bda35543e7953"
}